export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20cream%20and%20coral%20abstract%20geometric%20background%20with%20subtle%20floating%20ecommerce%20shopping%20elements%2C%20gentle%20layered%20shapes%2C%20elegant%20gradients%2C%20modern%20minimalist%20aesthetic%2C%20airy%20clean%20composition%2C%20no%20text%2C%20soft%20dreamy%20lighting%2C%20warm%20neutral%20palette%2C%20high%20end%20editorial%20style%2C%20sophisticated%20atmosphere&width=1800&height=1000&seq=yoybuy-hero-v2-01&orientation=landscape"
        alt="Yoybuy Sheet background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/25 mb-6">
            <div className="w-2 h-2 rounded-full bg-accent-400"></div>
            <span className="text-background-50 text-xs font-medium tracking-wide uppercase">
              Таблицы для шоппинга
            </span>
          </div>

          <h1 className="font-heading font-extrabold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4">
            Yoybuy Sheet — Ваш гид
            <br />
            по лучшим находкам
          </h1>

          <p className="text-background-50/80 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
            Полные таблицы со ссылками на товары для шоппинга через Yoybuy. Найдите лучшие товары по лучшим ценам.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-heading font-semibold text-sm hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line"></i>
              Купить сейчас
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/60 text-background-50 font-heading font-semibold text-sm hover:bg-background-50/10 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              Yoybuy Sheet
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}